/** CRM — lecture seule (DT décision A6) : contexte Party/contact d'une tâche,
 * personnes liées, résolution des acteurs RACI `contact`. Aucune écriture. */
import { crmRequest } from "./client";

export interface CrmParty {
  id: string;
  tenant_id: string;
  party_type: "person" | "organization";
  brand_url?: string;
  display_name: string;
  status: "active" | "merged" | "deleted";
  owner_id?: string;
  consent_status?: "granted" | "revoked" | null;
  created_at: string;
  updated_at: string;
}

export interface CrmRelationship {
  id: string;
  tenant_id: string;
  party_a_id: string;
  party_b_id: string;
  relationship_type_code: string;
  valid_from: string;
  valid_to?: string | null;
}

export interface CrmRole {
  id: string;
  tenant_id: string;
  person_party_id: string;
  organization_party_id: string;
  work_code: string;
  intensity?: number | null;
  valid_from: string;
  valid_to?: string | null;
}

interface CrmPage<T> {
  items: T[];
  limit?: number;
  offset?: number;
}

export function listParties(params?: {
  party_type?: "person" | "organization";
  q?: string;
  limit?: number;
  offset?: number;
}): Promise<CrmPage<CrmParty>> {
  return crmRequest({ method: "GET", url: "/parties", params });
}

export function getParty(id: string): Promise<CrmParty> {
  return crmRequest({ method: "GET", url: `/parties/${id}` });
}

export function listRelationships(
  partyId: string,
): Promise<CrmPage<CrmRelationship>> {
  return crmRequest({
    method: "GET",
    url: "/relationships",
    params: { party_id: partyId },
  });
}

export function listRoles(partyId: string): Promise<CrmPage<CrmRole>> {
  return crmRequest({
    method: "GET",
    url: "/roles",
    params: { party_id: partyId },
  });
}
